import { createFileRoute } from '@tanstack/react-router';
import { CatalogImportPage } from '@features/admin/catalog-import';

export const Route = createFileRoute('/admin/catalog-import/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <CatalogImportPage />;
}
